export default {
  methods: {
    openModal() {
      this.emitter.emit("openModal", true);
    }
  }
};
